import React from 'react'
import { useUser } from 'src/hook/useUser'
import { faPenLine } from '@fortawesome/pro-light-svg-icons/faPenLine'
import { ThemeMode } from '@hotmart/space-lib/dist/styles/themes/enum'
import { Icon } from 'src/components'
import i18n from 'src/i18n'
import { ContainerMenuBar, CustomButton } from './linkEditor.styles'
import { LinkEditorProps } from './linkEditor.types'

const LinkEditor: React.FC<LinkEditorProps> = ({ onOpenModal }) => {
  const { theme } = useUser()

  return (
    <ContainerMenuBar className="_align-items-center _border-0 _bg-white _rounded">
      <CustomButton
        className="_d-flex _align-items-center _px-2 _font-14"
        $theme={theme as ThemeMode}
        onClick={onOpenModal}
      >
        <Icon size="1x" icon={faPenLine} />
        <p className="_mb-0 _ml-3">{i18n.t('modal_edit_link.edit_link')}</p>
      </CustomButton>
    </ContainerMenuBar>
  )
}

export default LinkEditor
